import { ChangeDetectionStrategy, Component, model, ModelSignal, output, OutputEmitterRef, signal, WritableSignal } from '@angular/core';
import { ButtonComponent, ExpanderComponent } from '@libs/common/components';
import { QuickOrderSelectionModel, ShoppingListItemModel } from '@libs/shop/models';
import { ShoppingListItemComponent } from '../../shopping-list/shopping-list-items/shopping-list-item/shopping-list-item.component';

@Component({
  selector: 'ui-quick-order-product-selection',
  imports: [
    ExpanderComponent,
    ShoppingListItemComponent,
    ButtonComponent,
  ],
  templateUrl: './quick-order-product-selection.component.html',
  styleUrl: './quick-order-product-selection.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuickOrderProductSelectionComponent {
  public productsToSelect: ModelSignal<QuickOrderSelectionModel[]> = model.required<QuickOrderSelectionModel[]>();

  public productsSelected: OutputEmitterRef<ShoppingListItemModel[]> = output();

  public selectionGroups: WritableSignal<Record<string, string[] | undefined>> = signal({});

  public selectionChanged(key: string, sku: string, selected: boolean): void {
    const groups: Record<string, string[] | undefined> = this.selectionGroups();
    let currentGroup: string[] = groups[key] ?? [];

    if (selected) {
      currentGroup.push(sku);
    } else {
      currentGroup = currentGroup.filter(x => x !== sku);
    }

    groups[key] = currentGroup;
    this.selectionGroups.set(groups);
  }

  public emitProductsSelected(choice: QuickOrderSelectionModel): void {
    const selected: string[] = this.selectionGroups()[choice.key] ?? [];
    const items: ShoppingListItemModel[] = choice.items.filter(x => selected.includes(x.sku));

    this.productsToSelect.set(this.productsToSelect().filter(x => x.key !== choice.key));
    this.productsSelected.emit(items);
  }

  public removeProductFromGroup(key: string, sku: string): void {
    let currentProducts: QuickOrderSelectionModel[] = this.productsToSelect();
    const currentChoiceIndex: number = currentProducts.findIndex(x => x.key === key);

    if (currentChoiceIndex === -1) {
      return;
    }

    currentProducts[currentChoiceIndex].items = currentProducts[currentChoiceIndex].items.filter(x => x.sku !== sku);

    if (currentProducts[currentChoiceIndex].items.length <= 0) {
      currentProducts = currentProducts.filter(x => x.key !== key);
    }

    this.productsToSelect.set(currentProducts);
  }
}
